import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-company',
  templateUrl: './create-company.component.html',
  styleUrls: ['./create-company.component.scss']
})
export class CreateCompanyComponent implements OnInit {
  @BlockUI('section-blocks') blockUI: NgBlockUI;
  companyForm: FormGroup; // Form için tanımlama

  categories: any[] = [];
  currencies: any[] = [];
  unitTypes: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private currencyService: CurrencyService,
    private categoryService: CategoryService,
    private companyService: CompanyService,
    private toastrService: ToastrService) {

    this.companyForm = this.fb.group({
      title: ['', Validators.required],
      currencyId: [1, Validators.required],
      categoryId: [null],
      discountRate: [0],
      futureDay: [null]
    });
  }

  async ngOnInit() {
    await this.getAllCategories()
    await this.getAllCurrencies();
  }

  async getAllCurrencies() {
    const currency = await this.currencyService.getAllPageCurrency(0, 100, '');
    this.currencies = currency.currenies;
    console.log(this.currencies);
  }


  async getAllCategories() {
    const category = await this.categoryService.getAllCategory(0, 100, '', 2);
    this.categories = category.categories;
    console.log(this.categories);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSubmit() {
    this.blockUI.start("Firma ekleniyor...");
    if (this.companyForm.valid) {
      console.log(this.companyForm.value);
      const response = await await this.companyService.createCompany({
        companyName: this.companyForm.value.title,
        currencyId: this.companyForm.value.currencyId,
        categoryId: this.companyForm.value.categoryId,
        discountRate: this.companyForm.value.discountRate,
        futuresDay: 15,
        phoneNumber:null
      });
      if(response.status == true){
        this.blockUI.stop();
        this.toastrService.success(response.message);
        this.companyService.sendEvent(true);
        this.closeModal();
      }else{
        this.blockUI.stop();
        this.toastrService.error(response.message);
      }
    }
  }
}
